import { FunctionComponent } from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";

/**
 * Renders an icon within a fixed-width span, with an optional tooltip on hover.
 */
export default function IconSpan({ icon: Icon, width = 60, tooltip }: {
    /** The icon component to render. */
    icon: FunctionComponent;
    /** Width of the icon span in pixels (default: 60). */
    width?: number;
    /** Tooltip text displayed on hover. */
    tooltip?: string | React.JSX.Element;
}) {
    const icon = <span className="d-inline-block me-1" style={{ width, padding: "0 15px" }}>
        <Icon />
    </span>;

    if (tooltip) {
        return (
            <OverlayTrigger placement="right" overlay={<Tooltip id="user-menu-tooltip">{tooltip}</Tooltip>}>
                <div>{icon}</div>
            </OverlayTrigger>
        );
    }
    return icon;
}
